// App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter, useRoutes, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import About from './pages/About';
import NoPage from './pages/NoPage';
import './App.css';

const API_URL = 'https://alb.deardiary.io';

interface UserInfo {
  name?: string;
  nickname?: string;
  email?: string;
  sub?: string;
  picture?: string;
}

function Routes({ user }: { user: UserInfo | null }) {
  const routes = useRoutes([
    { path: '/', element: user ? <Navigate to="/dashboard" /> : <Home /> },
    { path: '/home', element: user ? <Navigate to="/dashboard" /> : <Home /> },
    { path: '/dashboard', element: user ? <Dashboard user={user} /> : <Navigate to="/home" /> },
    { path: '/about', element: <About /> },
    { path: '*', element: <NoPage /> },
  ]);

  return routes;
}

function App() {
  const [user, setUser] = useState<UserInfo | null | undefined>(undefined);

  useEffect(() => {
    // Check if we just got redirected back from Auth0 with an access_token
    const params = new URLSearchParams(window.location.search);
    const token = params.get('access_token');
    if (token) {
      localStorage.setItem('access_token', token);
      // Clean the token out of the URL and redirect to dashboard
      window.history.replaceState({}, document.title, '/dashboard');
    }

    // Verify the stored token by calling /auth/me
    const fetchAuthStatus = async () => {
      const storedToken = localStorage.getItem('access_token');
      if (!storedToken) {
        setUser(null);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${storedToken}` },
        });
        if (response.ok) {
          const data = await response.json();
          setUser(data);
        } else {
          localStorage.removeItem('access_token');
          setUser(null);
        }
      } catch {
        localStorage.removeItem('access_token');
        setUser(null);
      }
    };

    fetchAuthStatus();
  }, []);

  return (
    <div>
      <BrowserRouter>
        {user !== undefined && <Routes user={user} />}
      </BrowserRouter>
    </div>
  );
}

export default App;
